export const HEADER_SET_MENU_VISIBLE = 'HEADER_SET_MENU_VISIBLE';
